module.exports = __webpack_public_path__ + "images/icons/care-coach.afc5f6544d8a2da0e63412f5d79e934f.png";